<div class="row pt-5">
  <ng-container *ngIf="counsels$ | async as counsels">
    <div class="col-3 hide-table">
      <h2 class="mb-3">{{ 'GSEC_DOCTORS' | translate }}</h2>

      <ng-container *ngFor="let doctor of counsels.doctors; index as i">
        <app-user-basic
          class="d-flex mb-3"
          [user]="doctor"
          [srtIndex]="'rowIndex -' + i"
          [hasTableSizeLimit]="true"
        ></app-user-basic>
      </ng-container>
    </div>
    <div class="col-3 hide-table">
      <h2 class="mb-3">{{ 'GSEC_PATIENTS' | translate }}</h2>
      <ng-container *ngFor="let patient of counsels.patients; index as i" class="accordion-content">
        <app-user-basic
          class="d-flex mb-3"
          [user]="patient"
          [srtIndex]="'rowIndex -' + i"
          [hasTableSizeLimit]="true"
        ></app-user-basic>
      </ng-container>
    </div>
    <div class="col-6 hide-table">
      <h2 class="mb-3">{{ 'GSEC_ADMIN' | translate }}</h2>
      <ng-container *ngFor="let admin of counsels.admins; index as i">
        <app-user-basic
          class="d-flex mb-3"
          [user]="admin"
          [srtIndex]="'rowIndex -' + i"
          [hasTableSizeLimit]="true"
        ></app-user-basic>
      </ng-container>
    </div>
    <div class="hide-accordion">
      <button accordion class="accordion" type="button">
        <b>{{ 'GSEC_DOCTORS' | translate }}</b>
      </button>
      <div class="accordion-content">
        <ng-container *ngFor="let doctor of counsels.doctors; index as i" class="accordion-content">
          <app-user-basic
            class="d-flex mb-3"
            [user]="doctor"
            [srtIndex]="'rowIndex -' + i"
            [hasTableSizeLimit]="true"
          ></app-user-basic>
        </ng-container>
      </div>

      <button accordion class="accordion" type="button">
        <b>{{ 'GSEC_PATIENTS' | translate }}</b>
      </button>
      <div class="accordion-content">
        <ng-container *ngFor="let patient of counsels.patients; index as i" class="accordion-content">
          <app-user-basic
            class="d-flex mb-3"
            [user]="patient"
            [srtIndex]="'rowIndex -' + i"
            [hasTableSizeLimit]="true"
          ></app-user-basic>
        </ng-container>
      </div>
      <button accordion class="accordion" type="button">
        <b>{{ 'GSEC_ADMIN' | translate }}</b>
      </button>
      <div class="accordion-content">
        <ng-container *ngFor="let admin of counsels.admins; index as i">
          <app-user-basic
            class="d-flex mb-3"
            [user]="admin"
            [srtIndex]="'rowIndex -' + i"
            [hasTableSizeLimit]="true"
          ></app-user-basic>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
